/**
 * vCard 3.0 builder + downloader.
 * Works for businesses or individual agents/pros.
 */
export function buildVCard({
  name,
  title,
  company,
  phone,
  email,
  website,
  listingUrl,
  address,
  city,
  state,
  zip,
  logoUrl,
  category,
  isIndividual = false,
}) {
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
  ];

  if (isIndividual) {
    // Individuals → N: Last;First
    const parts = (name || "").trim().split(/\s+/);
    const first = parts.slice(0, -1).join(" ") || name;
    const last = parts.length > 1 ? parts[parts.length - 1] : "";
    lines.push(`N:${escape_(last)};${escape_(first)};;;`);
    lines.push(`FN:${escape_(name)}`);
    if (title) lines.push(`TITLE:${escape_(title)}`);
    if (company) lines.push(`ORG:${escape_(company)}`);
  } else {
    lines.push(`FN:${escape_(name)}`);
    lines.push(`N:;${escape_(name)};;;`);
    lines.push(`ORG:${escape_(name)}`);
    if (category) lines.push(`TITLE:${escape_(category)}`);
  }

  if (phone) lines.push(`TEL;TYPE=WORK,VOICE:${escape_(phone)}`);
  if (email) lines.push(`EMAIL;TYPE=WORK:${escape_(email)}`);
  if (website) lines.push(`URL;TYPE=WORK:${escape_(website)}`);
  if (listingUrl) lines.push(`URL;TYPE=LocalBest:${escape_(listingUrl)}`);

  const adrStreet = address || "";
  const adrCity = city || "";
  const adrState = state || "";
  const adrZip = zip || "";
  if (adrStreet || adrCity || adrState || adrZip) {
    lines.push(`ADR;TYPE=WORK:;;${escape_(adrStreet)};${escape_(adrCity)};${escape_(adrState)};${escape_(adrZip)};`);
  }

  if (logoUrl) {
    if (isIndividual) lines.push(`PHOTO;VALUE=URI:${logoUrl}`);
    else lines.push(`LOGO;VALUE=URI:${logoUrl}`);
  }

  lines.push("NOTE:Powered by LocalBest.ai");
  lines.push("END:VCARD");
  return lines.join("\r\n");
}

function escape_(value) {
  return String(value || "").replace(/([\\,;])/g, "\\$1").replace(/\r?\n/g, "\\n");
}

export function downloadVCard(filename, vcardText) {
  const blob = new Blob([vcardText], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".vcf") ? filename : `${filename}.vcf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 500);
}
